// import {NgClass} from '@angular/common';
import { ViewChild, Component, ElementRef, Input, Output, EventEmitter, OnInit, AfterViewChecked } from '@angular/core';
// import { Control } from '@angular/common';
// import {FormControl, FormGroup} from '@angular/forms';
// import { LocationSearchComponent } from '../location-search/locationsearch.component';
import { EventsService } from '../shared/Events.service';
import Utilities from '../utilities';
import { SettingsService } from '../shared/settings/settings.service';
// import {TranslatePipe} from 'ng2-translate/ng2-translate';
import GeometryService = require('esri/tasks/GeometryService');
import ProjectParameters = require('esri/tasks/support/ProjectParameters');
import SpatialReference = require('esri/geometry/SpatialReference');
import Point = require('esri/geometry/Point');
import WebMercatorUtils = require('esri/geometry/support/webMercatorUtils');
import EsriRequest = require('esri/request');
import { TranslateService} from 'ng2-translate/ng2-translate';

declare let componentHandler: any;


@Component({
    selector: 'voter-verify',
    template: require('./verification.component.html')
    // directives: [LocationSearchComponent]
    // pipes: [TranslatePipe]
})

export class VerificationComponent implements OnInit, AfterViewChecked  {
    @Output() onValidLocation = new EventEmitter<boolean>();
    @Output() onGeolocationError = new EventEmitter<string>();
    @Input() inputDrawer: boolean = false;

    appSettings: Object;
    monthInputVal:number;
    dayInputVal:number;
    yearInputVal:number;  
    infoViewVal:string = "";

    isSearchInvoked = false;
    isGeolocationInProgress = false;
    isVoterRegistered = false;
    isValidAddress = false;
    isValidDOB = false;
    selectedAddressSuggestion: Object 
    selectedAddressObject: Object;

    drawerToggle:Element;
    drawer:Element;
    obfuscator:Element;
   
    // langValue:string = "en";
    error: any;
    checkVal: boolean = false;

    urlQueryTab: string = "";
    urlQueryAddress: string = "";
    urlQueryCity: string = "";
    urlQueryZip: string = "";
    urlQueryXcoord: string = "";
    urlQueryYcoord: string = "";
    urlQueryDOB:string = "";
    selectOptions:Array<string> = ["tabPollingPlace", "tabRegistration", "tabDistricts", "tabOfficials", "tabCandidates", "tabBallots", "tabMap", "tabFAQ"];
    
//    changeLanguageControl:FormControl = new FormControl(true);
//    loginControl: FormControl = new FormControl('');
    //  myForm = new FormGroup({
    //     changeLanguage: this.changeLanguageCtrl,
       
    // });


    // myGroup = new FormGroup({
    //    changeLanguageControl: new FormControl()
    // });
    
//  myForm = new FormGroup({
//    changeLanguage: 
//  });
    
    // monthInputControl = new FormControl();
    // dayInputControl = new FormControl();
    // yearInputControl = new FormControl();
    // viewSelectControl = new FormControl();

     constructor(private elRef: ElementRef, private _eventsService: EventsService, private _settingsService: SettingsService, private _translate: TranslateService) {
    //    this.changeLanguageControl.setValue(false);
        let urlQueryObject:any = {};
        for(var prop in dojo["queryToObject"](window.location.search.substring(1))){
            let propValue:string = dojo["queryToObject"](window.location.search.substring(1))[prop];
            let propCorr:string = prop.toLowerCase();
            urlQueryObject[propCorr] = propValue;
        }

        if(urlQueryObject.address){
            let urlSearchAddress:string = urlQueryObject.address;
            this.urlQueryAddress = urlSearchAddress;
            if(urlQueryObject.city){
                this.urlQueryCity = urlQueryObject.city.toString();
            }
            if(urlQueryObject.zip){
                this.urlQueryZip = urlQueryObject.zip.toString();
            }
            console.log("Verification Component: address - " + urlSearchAddress);
        }
        if(urlQueryObject.tab){
            let selectTab:string = urlQueryObject.tab;
            this.urlQueryTab = selectTab;
            console.log("Verification Component: tab - " + selectTab);
        }
        if(urlQueryObject.xcoord && urlQueryObject.ycoord){
            let selectCoords:object = {
                Xcoord: urlQueryObject.xcoord,
                Ycoord: urlQueryObject.ycoord
            };
            this.urlQueryXcoord = selectCoords["Xcoord"];
            this.urlQueryYcoord = selectCoords["Ycoord"];
            console.log("Verification Component: coords - " + selectCoords);
        }
        if(urlQueryObject.dob){
            let dob:string = urlQueryObject.dob;
            this.urlQueryDOB = dob;
            let dobArray:Array<string> = dob.split("-");
            if(dobArray.length == 3){
                this.yearInputVal = Number(dobArray[0]);
                this.monthInputVal = Number(dobArray[1]);
                this.dayInputVal = Number(dobArray[2]);
            }
        }
     }

    //setup the parameters for the information search
    setupSearch(address) {
        console.log(this.selectedAddressSuggestion["FullAddress"])

        //invoke valid voter address event
        this._eventsService.voterAddressValid(true);

        this._eventsService.setSelectedAddress(this.selectedAddressObject);
        
    }

    //Close the drawer if open
    closeDrawer () {

            //toggle the drawer panel
            this.drawer = document.getElementsByClassName('mdl-layout__drawer')[0];
            this.drawer.classList.contains('is-visible') ? this.drawer.classList.toggle('is-visible') : console.log("There was an issue closing the drawer");
            this.drawer.setAttribute("aria-hidden", "true");
            //toggle the obfuscation panel
            this.obfuscator = document.getElementsByClassName('mdl-layout__obfuscator')[0];
            this.obfuscator.classList.contains('is-visible') ? this.obfuscator.classList.toggle('is-visible') : console.log("There was an issue closing the obfuscator");

    }

    //invoke the information search
    searchClick() {

        let birthDate: string;
        let month: number = this.monthInputVal;
        let day: number = this.dayInputVal;
        let year: number = this.yearInputVal;
        let infoview: string = this.infoViewVal;

        console.log("Search button clicked: " + month + "/" + day + "/" + year );

       //format and validate the birthdate
        if (Utilities.isValidDate(day,month, year)) {
            birthDate = year + '-';
            if ((month + '').length == 1) {
                birthDate += '0' + month + '-';
            } else {
                birthDate += month + '-';
            }
            if ((day + '').length == 1) {
                birthDate += '0' + day;
            } else {
                birthDate += day;
            }
            
            //infor app that birthdate is validated
            this._eventsService.voterBirthdate(birthDate);

            console.log("Validated date: " + birthDate );
        } else {
            //alert(applicationStrings.birthDateError);
            console.log("birthdate not valid" );
            this._eventsService.voterBirthdate(null);
        }

        //set the active tab
        this._eventsService.setActiveTab(infoview);

        this.isSearchInvoked = true;

        //invoke the search event
        this._eventsService.voterSearchInvoked(this.selectedAddressObject);

        this.drawer = document.getElementsByClassName('mdl-layout__drawer')[0];
        this.drawer.setAttribute("aria-hidden", "true");
    }
    

    addressIsSelected(address:Object) {
    // selectedAddressItem
        address ? this.selectedAddressObject = address: null;

        this.selectedAddressSuggestion = address["addressSuggestion"];
        this.selectedAddressSuggestion ? this.setupSearch(address) : console.log("Address object Undefined");

        if(this.urlQueryXcoord != "" && this.urlQueryYcoord != "" && this.urlQueryAddress != ""){
            // setTimeout(() => {
            //     this.searchClick();
            // }, 3000);
            this.urlQueryXcoord = "";
            this.urlQueryYcoord = "";
            this.urlQueryAddress = "";
            this.urlQueryCity = "";
            this.urlQueryZip = "";
        }
    }

    //handle events from the address search input
    validateAddressToggle(validAddress:boolean) {
        this.isValidAddress = validAddress;
        if(this.infoViewVal != 'tabRegistration' && this.infoViewVal != 'tabEarlyVoting'){
            if(this.isValidAddress){
                this.searchClick();
            }

            //if address is cleared, clear out birthday
            if (!this.isValidAddress) {
            
                this.monthInputVal = null;
                this.dayInputVal = null;
                this.yearInputVal = null;
            }
        }else if(this.infoViewVal == 'tabRegistration'){
            if(this.urlQueryDOB != ""){
                if(this.isValidAddress){
                    this.searchClick();
                }
                //if address is cleared, clear out birthday
                if (!this.isValidAddress) {
                    this.monthInputVal = null;
                    this.dayInputVal = null;
                    this.yearInputVal = null;
                }
                this.urlQueryDOB = "";
            }
        }else if(this.infoViewVal == 'tabEarlyVoting'){
            
        }
    }

    // navToNextDateVal(element:Element) {
    //     if (element["TextLength"] >= 2) {
        

    //         document.getElementById("dayinput").focus();
    //     }
    // }

    //Upon component initialize, wire up event subscribers
    ngOnInit() {
        this._settingsService.getAppSettings().subscribe(
            settings => { 
                this.appSettings = settings[0];
            },
            err => { this.error = true }
        ); 


        if(this.urlQueryTab != ""){
            for(var i = 0; i < this.selectOptions.length; i++){
                if(this.urlQueryTab.toLowerCase() == this.selectOptions[i].toLowerCase()){
                    this.infoViewVal = this.selectOptions[i];
                    continue;
                }
            }
        }
        
        // if(this.urlQueryTab != "" && this.selectOptions.indexOf(this.urlQueryTab) != -1){
        //     this.infoViewVal = this.urlQueryTab;
        // }

        this._eventsService.activeTab$.subscribe(tabview => {
            this.infoViewVal = tabview;
        });
    }


    ngAfterViewChecked() {
        // componentHandler.upgradeAllRegistered();

    }

    // destroy map
    ngOnDestroy() {

    }
    
    getUserLocation(){
        if (navigator.geolocation) {
            this.isGeolocationInProgress = true;
            this._eventsService.startAddressFromGeolocation();
            navigator.geolocation.getCurrentPosition(this.showPosition.bind(this), this.locationError.bind(this));
        } else {
            //this.onGeolocationError.next("Geolocation is not supported by your browser.");
            this._translate.get("geolocationNotSupported").subscribe(text => this.onGeolocationError.next(text) );
        }
    }

    showPosition(position:any){
        console.log(position);
        var pt:Point = WebMercatorUtils.geographicToWebMercator(new Point({
            x:position.coords.longitude, 
            y:position.coords.latitude
        })) as Point;
        var gsvc:GeometryService = new GeometryService();
        gsvc.url = this.appSettings["geometryService"]["url"];
        var params:ProjectParameters = new ProjectParameters();
        params.geometries = [pt];
        params.outSR = new SpatialReference(this.appSettings["geometryService"]["outSR"]);
        gsvc.project(params).then(projectedGeometries => {
            this.geocodeCoordinates(projectedGeometries[0]);
        }, error => {
            this.isGeolocationInProgress = false;
            this._eventsService.setAddressFromGeolocation(null);
            this._translate.get("geolocationProjectionError").subscribe(text => this.onGeolocationError.next(text) );
        });
    }

    geocodeCoordinates(point:any){
        EsriRequest(this.appSettings["reverseGeocode"]["url"], {
            "query":{
                "location":point.x + ", " + point.y,
                "distance":this.appSettings["reverseGeocode"]["distance"],
                "outSR":this.appSettings["reverseGeocode"]["outSR"],
                "returnIntersection": this.appSettings["reverseGeocode"]["returnIntersection"],
                "f": this.appSettings["reverseGeocode"]["f"]
            }
        }).then(result => {
            console.log(result);
            if(result.data){
                this.setAddressFromLocation(result.data);
            }else{
                this.isGeolocationInProgress = false;
                this._eventsService.setAddressFromGeolocation(null);
                this._translate.get("geolocationGeocodeError").subscribe(text => this.onGeolocationError.next(text) );
            }
        }, error => {
            this.isGeolocationInProgress = false;
            this._eventsService.setAddressFromGeolocation(null);
            this._translate.get("geolocationGeocodeError").subscribe(text => this.onGeolocationError.next(text) );
        });
    }

    setAddressFromLocation(addressLocation:any){
        //let selectTab:string = "tabEarlyVoting";
        let selectTab:string = this.infoViewVal;
        if(!this.selectedAddressObject){
            this.infoViewVal = selectTab;
        }
        this.isGeolocationInProgress = false;
        this._eventsService.setAddressFromGeolocation(addressLocation);
    }

    locationError(error:any){
        this.isGeolocationInProgress = false;
        this._eventsService.setAddressFromGeolocation(null);
        switch(error.code) {
            case error.PERMISSION_DENIED:
                this._translate.get("geolocationDeniedForVIP").subscribe(text => this.onGeolocationError.next(text) );
                break;
            case error.POSITION_UNAVAILABLE:
                this._translate.get("geolocationPositionUnavailble").subscribe(text => this.onGeolocationError.next(text) );
                break;
            case error.TIMEOUT:
                this._translate.get("geolocationTimedout").subscribe(text => this.onGeolocationError.next(text) );
                break;
            case error.UNKNOWN_ERROR:
                this._translate.get("geolocationUnknownError").subscribe(text => this.onGeolocationError.next(text) );
                break;
            default:
                this._translate.get("geolocationUnknownError").subscribe(text => this.onGeolocationError.next(text) );
                break;
        }
    }

    inputDrawerCalc():boolean{
        if(this.inputDrawer == true){
            return true;
        }else{
            return false;
        }
    }

    onSearchOptionChange(event:any){
        //console.log(event);
    }

    onDOBChange(event:any){
        let month: number = this.monthInputVal;
        let day: number = this.dayInputVal;
        let year: number = this.yearInputVal;
        if (Utilities.isValidDate(day,month, year)) {
            this.isValidDOB = true;
        }else{
            this.isValidDOB = false;
        }
    }
}


// WEBPACK FOOTER //
// ./app/verification/verification.component.ts